//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "SfPrice",
  props: {
    regular: {
      type: [String, Number],
      default: null,
    },
    special: {
      type: [String, Number],
      default: null,
    },
    lowest: {
      type: [String, Number],
      default: null,
    },
    lowestPriceLabel: {
      type: [String],
      default: 'Lowest recent price',
    },
    currency: {
      type: String,
      default: null
    }
  },
};
